import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors, foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  root: {
    height: "105px",
    display: "flex",
    width: "100%",
    padding: "16px 24px",
    backgroundColor: semanticColors.background.primary,
    justifyContent: "space-between",
    borderBottom: `1px solid ${semanticColors.border.secondary}`,
    flexDirection: "column",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },
  rootTemplate: {
    height: "72px",
    display: "flex",
    width: "100%",
    padding: "16px 24px",
    backgroundColor: semanticColors.background.primary,
    justifyContent: "space-between",
    borderBottom: `1px solid ${semanticColors.border.secondary}`,
    flexDirection: "row",
    alignItems: "center",
  },
  templateTitle: {
    color: semanticColors.foreground.primary,
    fontWeight: foundations.typography.fontWeight.bold,
    fontSize: "28px",
    lineHeight: "40px",
  },
  navBarBreadcrumb: {
    display: "flex",
    width: "100%",
    height: "24px",
  },
  breadcrumbsLink: {
    fontSize: foundations.typography.fontSize.bodySmall,
    textDecorationLine: "underline",
    fontStyle: "normal",
    fontWeight: foundations.typography.fontWeight.normal,
    color: semanticColors.foreground.action,
    cursor: "pointer",
    "&:hover": {
      color: semanticColors.foreground.action,
    },
  },
  titleStyle: {
    fontSize: foundations.typography.fontSize.bodySmall,
    color: semanticColors.foreground.secondary,
    fontStyle: "normal",
    fontWeight: foundations.typography.fontWeight.normal,
    marginLeft: "4px",
  },
  navBarDetails: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  leftContent: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    overflow: "hidden",
  },
  title: {
    fontWeight: foundations.typography.fontWeight.bold,
    fontSize: "28px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  content: {
    display: "flex",
    alignItems: "flex-end",
    "& > *:not(:last-child)": {
      marginRight: "8px",
    },
  },
  editButton: {
    marginLeft: "8px",
    marginRight: "16px",
    color: semanticColors.foreground.action,
    fontSize: "12px",
    fontWeight: foundations.typography.fontWeight.normal,
    "& .MuiButton-startIcon svg": {
      fill: semanticColors.foreground.action,
    },
  },
  hideControls: {
    display: "none",
  },
});
